import { create } from 'zustand';
import { MenteeBulkStatusChangeCompletedPayload } from 'types';

interface useStatusChangeRunsStore {
  /** The most recently completed status-change run, as the event delivered it. */
  completedRun: MenteeBulkStatusChangeCompletedPayload | null;
  /**
   * Monotonic counter, bumped once per recorded run. Consumers key their effects on this rather
   * than on the payload or its correlation id. The payload survives a remount, so it is not a
   * signal that something new arrived, and a retry deliberately re-emits the same correlation, so
   * keying on that would suppress exactly the corrected result the retry exists to produce.
   */
  completedRunSeq: number;
  recordCompletedRun(payload: MenteeBulkStatusChangeCompletedPayload): void;
  setState(nextState: Partial<useStatusChangeRunsStore>): void;
}

export const initialStatusChangeRunsState = {
  completedRun: null,
  completedRunSeq: 0,
};

const useStatusChangeRuns = create<useStatusChangeRunsStore>(set => ({
  ...initialStatusChangeRunsState,
  recordCompletedRun: payload =>
    set(state => ({ ...state, completedRun: payload, completedRunSeq: state.completedRunSeq + 1 })),
  setState: nextState => set(state => ({ ...state, ...nextState })),
}));

export default useStatusChangeRuns;
